module.exports = __webpack_public_path__ + "img/story-mode-icon.75ba1ebb.svg";